// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3j6tp","file":"styles_file__31VxY"};